<ac-card>
  <ac-card-content>
    <div class="redemption-dialog">
      @switch (redemption().redemption_status) { @case('complete') {
      <app-redemption-dialog-header
        [step]="3"
        title="Redemption Complete"
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @case('failed') {
      <app-redemption-dialog-header
        [step]="3"
        [stepColor]="'failed'"
        title="Redemption Failed"
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @case('blocked') {
      <app-redemption-dialog-header
        [step]="3"
        [stepColor]="'blocked'"
        title="Redemption Under Review"
        [subtitle]="blockedSubtitle()"
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @case('aborted') {
      <app-redemption-dialog-header
        [step]="3"
        [stepColor]="'failed'"
        title="Redemption Canceled"
        subtitle="Your redemption has been canceled and your SC has been returned to your balance."
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } @default {
      <app-redemption-dialog-header
        [step]="3"
        title="Redemption in Progress"
        [hideBack]="true"
        [hideBalance]="true"
        (close)="close.emit(null)"
      />
      } }
      <div class="ac-flex ac-ctr">
        @switch (redemption().redemption_status) { @case('complete') {
        <app-lottie-animation
          [size]="132"
          path="payments_complete"
          [loop]="false"
        />
        } @case('failed') {
        <ac-icon iconKey="payment:fail" [size]="132" />
        } @case('blocked') {
        <app-lottie-animation
          [size]="132"
          path="payments_blocked"
          [loop]="false"
        />
        } @case('aborted') {
        <ac-icon iconKey="payment:fail" [size]="132" />
        } @default {
        <app-lottie-animation [size]="132" path="payments_pending" />
        } }
      </div>
      <ul class="redemption-dialog__crypto-confirm-table ac-body-md">
        @if (redemption().redemption_status !== 'blocked' && redemption().redemption_status !== 'aborted') { @if
        (redemption().payment_method_label) {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Method</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>{{ redemption().payment_method_label }}</div>
          </div>
        </li>
        }
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Time & Date
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ redemption().created_at | date : 'MMMM d, yyyy • h:mm a' }}
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Amount</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ redemption().amount | currency : 'USD' : 'symbol-narrow' }}
            </div>
          </div>
        </li>
        @if (redemption().transaction_fee_amount) {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Transfer Fee
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{
                redemption().transaction_fee_amount
                  | currency : 'USD' : 'symbol-narrow'
              }}
            </div>
          </div>
        </li>
        }
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Total Redemption
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ totalRedemptionAmount() | currency : 'USD' : 'symbol-narrow' }}
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Status</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div
              class="redemption-dialog__pill redemption-dialog__pill--{{
                redemption().redemption_status
              }}"
            >
              @if (redemption().redemption_status === 'created') { Pending }
              @else {
              {{ redemption().redemption_status | titlecase }}
              }
            </div>
          </div>
        </li>
        } @else {
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Amount</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ redemption().amount | currency : 'USD' : 'symbol-narrow' }}
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">Status</div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div
              class="redemption-dialog__pill redemption-dialog__pill--{{
                redemption().redemption_status
              }}"
            >
              @if (redemption().redemption_status === 'aborted') {
              Canceled
              } @else { Under Review }
            </div>
          </div>
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Time & Date
          </div>
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ redemption().created_at | date : 'MMMM d, yyyy • h:mm a' }}
            </div>
          </div>
        </li>
        }
      </ul>
      @if (redemption().redemption_status === 'blocked') {
      <div class="redemption-dialog__footer">
        @if (redemption().blocked_due_to_payment_method_verification) {
        <div class="redemption-dialog__footer-text ac-body-sm">
          We need to verify the card used for your purchase before this redemption can be released.
        </div>
        } @else {
        <div class="redemption-dialog__footer-text ac-body-sm">
          Contacting support will not speed up the review or processing time. You'll receive an email as soon as your redemption is approved and completed.
        </div>
        }
      </div>
      @if (redemption().blocked_due_to_payment_method_verification) {
      <button
        (click)="close.emit('additional-verification'); $event.preventDefault()"
        class="ac-btn-lg"
        mat-flat-button
      >
        Complete verification to continue
      </button>
      }
      <button
        (click)="cancelRedemption(); $event.preventDefault()"
        class="ac-btn-lg ac-danger"
        mat-flat-button
        [loading]="cancelInProgress()"
      >
        Cancel Redemption
      </button>
      }
    </div>
  </ac-card-content>
</ac-card>
